// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  color: var(--ion-color-primary);
  display: flex;
  flex-direction: column;
  background: #fff;
}

.header-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--ion-color-tertiary);
  width: 100%;
  height: 55px;
  margin-bottom: 20px;
}
.header-container .cross {
  margin-left: auto;
}

.separator {
  width: 100%;
  height: 1px;
  margin: 16px 0;
  background: white;
}

ion-icon {
  width: 32px;
  margin-right: 3px;
  padding: 4px;
  border-radius: 0;
}

.version {
  opacity: 0.3;
  font-size: x-small;
}

ion-row {
  align-items: center;
  padding: 2px;
  cursor: pointer;
}

ion-button {
  color: white;
  --background: rgba(255, 255, 255, 0.3);
  backdrop-filter: blur(4px);
}

.footer-lang {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
  max-width: max-content;
  margin-right: auto;
  padding: 3px;
  border-radius: var(--bg-radius);
}
.footer-lang div {
  height: 40px;
  width: 74px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  border-radius: 80px;
  border: 1px solid var(--ion-color-tertiary);
}
.footer-lang div p {
  font-family: AppFontMedium;
  font-size: 14px;
  line-height: 135%;
  letter-spacing: 0.02em;
  text-align: center;
  vertical-align: middle;
  text-transform: uppercase;
  color: var(--ion-color-tertiary);
}
.footer-lang div ion-icon {
  padding: 0;
  height: 23px;
  width: 23px;
  border-radius: 50px;
  overflow: hidden;
  margin-right: 4.5px;
}
.footer-lang div.selected {
  background: var(--ion-color-tertiary);
  border-color: var(--ion-color-tertiary);
}
.footer-lang div.selected p {
  color: var(--color-white);
}
.footer-lang div.selected ion-icon {
  border: 1px solid var(--color-white);
}

ion-col {
  font-size: 13px;
  font-family: AppFontSemiBold;
  color: #000;
}

.selected {
  opacity: 1 !important;
}

.lang-title {
  max-width: 90%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  margin: 0px;
}

ion-icon {
  zoom: 1.1;
}

.logout {
  margin: 20px 0px 0px 10px;
}
.logout ion-button {
  padding: 10px 0px;
  font-family: AppFont, sans-serif;
  text-transform: capitalize;
  --background: white;
  color: var(--ion-color-primary);
  font-weight: 700;
}
.logout ion-button ion-icon {
  zoom: 1;
  color: var(--ion-color-primary);
}

.header-wrap {
  margin: 10px;
}

.lang-block {
  margin-top: 10rem;
  padding: 10px;
}

.version {
  position: absolute;
  bottom: 3px;
  right: 10px;
}

.link {
  display: flex;
  align-items: center;
}

.top-corner {
  position: fixed;
  top: 0px;
  left: 0;
  width: 17.3%;
  aspect-ratio: 114/153;
}
@media (min-width: 991px) {
  .top-corner {
    display: none;
  }
}

.logo {
  width: 21px;
  height: 27px;
  padding-left: 16px;
}

.item {
  padding-left: 10px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/menu-modal/menu-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAEA;EACC,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;AADD;;AAGA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,2CAAA;EACA,WAAA;EACA,YAAA;EACA,mBAAA;AAAD;AAEC;EACC,iBAAA;AAAF;;AAIA;EACC,WAAA;EACA,WAAA;EACA,cAAA;EACA,iBAAA;AADD;;AAIA;EACC,WAAA;EACA,iBAAA;EACA,YAAA;EACA,gBAAA;AADD;;AAIA;EACC,YAAA;EACA,kBAAA;AADD;;AAIA;EACC,mBAAA;EACA,YAAA;EACA,eAAA;AADD;;AAIA;EACC,YAAA;EACA,sCAAA;EACA,0BAAA;AADD;;AAGA;EACC,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;EACA,sBAAA;EACA,kBAAA;EACG,YAAA;EACA,+BAAA;AAAJ;AAEC;EACC,YAAA;EACA,WAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;EACM,2CAAA;AAAR;AAEE;EACC,0BAAA;EACA,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACS,gCAAA;AAAZ;AAEE;EACC,UAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,mBAAA;AAAH;AAGM;EACE,qCAAA;EACA,uCAAA;AADR;AAGQ;EACE,yBAAA;AADV;AAIQ;EACE,oCAAA;AAFV;;AAOA;EACC,eAAA;EACA,4BAAA;EACA,WAAA;AAJD;;AAOA;EACC,qBAAA;AAJD;;AAMA;EACC,cAAA;EACA,mBAAA;EACA,gBAAA;EACA,uBAAA;EACA,WAAA;AAHD;;AAKA;EACC,SAAA;AAFD;;AAIA;EACC,yBAAA;AADD;AAEC;EACC,iBAAA;EACA,gCAAA;EACA,0BAAA;EACA,mBAAA;EACA,+BAAA;EACA,gBAAA;AAAF;AACE;EACC,OAAA;EACA,+BAAA;AACH;;AAIA;EACC,YAAA;AADD;;AAKA;EACC,iBAAA;EACA,aAAA;AAFD;;AAKA;EACC,kBAAA;EACA,WAAA;EACA,WAAA;AAFD;;AAKA;EACC,aAAA;EACA,mBAAA;AAFD;;AAKA;EACC,eAAA;EACA,QAAA;EACA,OAAA;EACA,YAAA;EACA,qBAAA;AAFD;ACnKE;EDgKF;IAQE,aAAA;EADA;AACF;;AAIA;EACC,WAAA;EACA,YAAA;EACA,kBAAA;AADD;;AAIA;EACC,kBAAA;AADD","sourcesContent":["@use '../../../theme/mixins' as *;\n\n.wrapper {\n\tcolor: var(--ion-color-primary);\n\tdisplay: flex;\n\tflex-direction: column;\n\tbackground: #fff;\n}\n.header-container {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\tbackground-color: var(--ion-color-tertiary);\n\twidth: 100%;\n\theight: 55px;\n\tmargin-bottom: 20px;\n\n\t.cross {\n\t\tmargin-left: auto;\n\t}\n}\n\n.separator {\n\twidth: 100%;\n\theight: 1px;\n\tmargin: 16px 0;\n\tbackground: white;\n}\n\nion-icon {\n\twidth: 32px;\n\tmargin-right: 3px;\n\tpadding: 4px;\n\tborder-radius: 0;\n}\n\n.version {\n\topacity: 0.3;\n\tfont-size: x-small;\n}\n\nion-row {\n\talign-items: center;\n\tpadding: 2px;\n\tcursor: pointer;\n}\n\nion-button {\n\tcolor: white;\n\t--background: rgba(255, 255, 255, 0.3);\n\tbackdrop-filter: blur(4px);\n}\n.footer-lang {\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n\tgap: 10px;\n\tmax-width: max-content;\n\tmargin-right: auto;\n    padding: 3px;\n    border-radius: var(--bg-radius);\n\n\tdiv {\n\t\theight: 40px;\n\t\twidth: 74px;\n\t\tdisplay: flex;\n\t\tjustify-content: center;\n\t\talign-items: center;\n\t\tcursor: pointer;\n\t\tborder-radius: 80px;\n        border: 1px solid var(--ion-color-tertiary);\n\n\t\tp {\n\t\t\tfont-family: AppFontMedium;\n\t\t\tfont-size: 14px;\n\t\t\tline-height: 135%;\n\t\t\tletter-spacing: 0.02em;\n\t\t\ttext-align: center;\n\t\t\tvertical-align: middle;\n\t\t\ttext-transform: uppercase;\n            color: var(--ion-color-tertiary);\n\t\t}\n\t\tion-icon {\n\t\t\tpadding: 0;\n\t\t\theight: 23px;\n\t\t\twidth: 23px;\n\t\t\tborder-radius: 50px;\n\t\t\toverflow: hidden;\n\t\t\tmargin-right: 4.5px;\n\t\t}\n\n      &.selected {\n        background: var(--ion-color-tertiary);\n        border-color: var(--ion-color-tertiary);\n\n        p {\n          color: var(--color-white);\n        }\n\n        ion-icon {\n          border: 1px solid var(--color-white);\n        }\n      }\n\t}\n}\nion-col {\n\tfont-size: 13px;\n\tfont-family: AppFontSemiBold;\n\tcolor: #000;\n}\n\n.selected {\n\topacity: 1 !important;\n}\n.lang-title {\n\tmax-width: 90%;\n\twhite-space: nowrap;\n\toverflow: hidden;\n\ttext-overflow: ellipsis;\n\tmargin: 0px;\n}\nion-icon {\n\tzoom: 1.1;\n}\n.logout {\n\tmargin: 20px 0px 0px 10px;\n\tion-button {\n\t\tpadding: 10px 0px;\n\t\tfont-family: AppFont, sans-serif;\n\t\ttext-transform: capitalize;\n\t\t--background: white;\n\t\tcolor: var(--ion-color-primary);\n\t\tfont-weight: 700;\n\t\tion-icon {\n\t\t\tzoom: 1;\n\t\t\tcolor: var(--ion-color-primary);\n\t\t}\n\t}\n}\n\n.header-wrap {\n\tmargin: 10px;\n}\n\n\n.lang-block {\n\tmargin-top: 10rem;\n\tpadding: 10px;\n}\n\n.version {\n\tposition: absolute;\n\tbottom: 3px;\n\tright: 10px;\n}\n\n.link {\n\tdisplay: flex;\n\talign-items: center;\n}\n\n.top-corner {\n\tposition: fixed;\n\ttop: 0px;\n\tleft: 0;\n\twidth: 17.3%;\n\taspect-ratio: 114 / 153;\n\n\t@include desktop {\n\t\tdisplay: none;\n\t}\n}\n\n.logo {\n\twidth: 21px;\n\theight: 27px;\n\tpadding-left: 16px;\n}\n\n.item {\n\tpadding-left: 10px;\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
